import { render, staticRenderFns } from "./SectionTag.vue?vue&type=template&id=d76cbc28&scoped=true&lang=pug&"
import script from "./SectionTag.vue?vue&type=script&lang=js&"
export * from "./SectionTag.vue?vue&type=script&lang=js&"
import style0 from "./SectionTag.vue?vue&type=style&index=0&id=d76cbc28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76cbc28",
  null
  
)

export default component.exports